import {
  Img,
  Heading,
  Button,
  SelectBox,
  TextArea,
  Input,
} from "../../components";
import React from "react";
import useIsMobile from "utils/useIsMobile";

const dropDownOptions = [
  { label: "Option1", value: "option1" },
  { label: "Option2", value: "option2" },
  { label: "Option3", value: "option3" },
];

export default function LandingpagewipRowOne() {
  const isMobile = useIsMobile();
  return (
    <div className="flex justify-center h-[fit-content]">
      <div className="flex justify-center px-14 md:px-5">
        <div className="flex w-full items-center justify-between gap-4 md:flex-col">
          <div className="flex w-[46%] flex-col items-center gap-2 md:w-full sm:w-[100vw]">
            <div className="mr-14 mt-12 flex w-[60%] mb-[1vw] items-center justify-center md:mr-0">
              <Img
                src="/images/cloud-left.svg" // Căile au fost corectate
                alt="Dialog Balloon"
                className="relative z-10 w-[16vw] md:w-[50vw] sm:w-[90vw]"
              />
              <Heading
                as="h2"
                className=" mt-[-0.5%] absolute z-20 text-center !font-grandstander text-[1.4vw] font-normal uppercase md:text-[22px]"
              >
                <span className="font-bold block">Lifetoon in Action!</span>
                <span> (Preview 👀 Only) </span>
              </Heading>
            </div>
            <fieldset disabled className="flex flex-col gap-[1.6vw] w-[30vw] sm:w-[90vw] sm:mt-[20px] md:w-[60vw] rounded-[24px] border-r border-solid border-avatar-__-_-50 bg-white p-6 shadow-lg sm:p-5 sm:gap-[32px]">
              <div className="flex items-center justify-between gap-5">
                <Img
                  src="images/img_vector.svg"
                  alt="Vector"
                  className="h-[1.6vw] md:h-[30px] object-contain"
                />
                <Img
                  src="images/img_brush.svg"
                  alt="Brush"
                  className="h-[1.2vw] md:h-[22px]"
                />
              </div>
              <div className="flex flex-col gap-[46px]">
                <div className="flex flex-col gap-[1.2vw] sm:gap-[24px]">
                  <div className="flex flex-col items-start gap-[.8vw] ms:gap-[12px]">
                    <Heading as="h3" className="text-[1vw] md:text-[20px] font-medium">
                      Upload a photo
                    </Heading>
                    <Input
                      color="deep_purple_50"
                      name="weburl"
                      placeholder={`image_01.jpg`}
                      className="gap-4 h-[2.1vw] md:h-[40px] rounded-[20px] border-[0.93px] border-gray-300_01 px-2.5 font-lora italic"
                      disabled
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-wrap items-start justify-between gap-5">
                      <Heading
                        as="h4"
                        className="self-center text-[1vw] md:text-[20px] font-medium"
                      >
                        Describe your story
                      </Heading>
                      <Heading
                        size="textxs"
                        as="h5"
                        className="text-[.8vw] md:text-[16px] font-normal !text-blue_gray-20201"
                      >
                        393/500
                      </Heading>
                    </div>
                    <TextArea
                      shape="round"
                      name="prompttwo_one"
                      value={`He was nervous. I could tell by the way he kept fiddling with his jacket pocket. It wasn’t a grand setup. No flash mob, no photographer hiding in the bushes. Just us. A quiet bench. The sound of leaves crunching under our feet. He forgot half the words he wanted to say. I said yes before he even finished the sentence. And somehow, that made it perfect. Because it felt real. It felt like us.`}
                      className="text-dark_blue_secondary h-[8vw] md:h-[160px] p-2.5 text-[.8vw] md:text-[16px] rounded-lg !border-[0.93px] !border-deep_purple-a200 px-2.5 font-lora italic resize-none sm:h-[285px]"
                      disabled
                    />
                  </div>
                  <div className="flex flex-col items-start gap-2">
                    <Heading
                      as="h6"
                      className="text-[.9vw] md:text-[18px] font-medium"
                    >
                      Choose your comic look
                    </Heading>
                    <SelectBox
                      shape="round"
                      indicator={
                        <Img
                          src="images/img_arrowdown.svg"
                          alt="Arrow Down"
                          className="h-[1vw]"
                        />
                      }
                      name="styledropdown"
                      placeholder={`American Comic Book`}
                      options={dropDownOptions}
                      className="h-[2.2vw] md:h-[40px] px-2.5 text-[.8vw] md:text-[16px] gap-4 self-stretch rounded-lg border-[0.93px] border-solid border-gray-30301 px-2.5 font-lora italic cursor-not-allowed"
                      disabled
                    />
                  </div>
                </div>
                <Button
                  color="deep_purple_A200"
                  size="sm"
                  shape="round"
                  className="h-[2vw] text-[.8vw] md:text-[16px] md:h-[40px] gap-2 self-stretch rounded-[1vw] px-[1.8vw] sm:px-5 cursor-not-allowed pointer-events-none"
                  disabled
                >
                  Creating your comic...
                </Button>
              </div>
            </fieldset>
          </div>
          <div className="relative flex-1 sm:w-[100vw] content-center md:h-auto md:w-[50%] md:mt-[40px]">
            <div className="flex flex-1 flex-col items-start sm:items-center sm:justify-center">
              <div className="relative z-[1] ml-16 sm:m-0 flex items-start justify-center md:ml-0 md:h-auto md:translate-y-[-20px] sm:mt-[56px] sm:w-[60vw]">
                <Img
                  src="/images/cloud-right.svg" // Căile au fost corectate
                  alt="White Dialog Balloon"
                  className="w-[18vw] md:w-[50vw] sm:w-[60vw]"
                />
                <Heading
                  as="p"
                  className="absolute text-center !font-grandstander text-[1.6vw] md:mt-[50px] sm:mt-[20%] font-normal uppercase ml-[-1vw] md:text-[20px] md:mt-[6vw] mt-[4vw]"
                >
                  <span>tHIS COULD BE YOUR</span>
                  <span className="block">
                    {" "}
                    COMIC <span className="font-bold">BOOK</span> !😱
                  </span>
                </Heading>
              </div>
              <div className="relative mr-2.5 mt-[-14px] md:mt-[-40px] flex items-center  justify-center md:mr-0 sm:flex-col">
                {!isMobile && (
                  <Img
                    src="images/img_vector_9.svg"
                    alt="Vectornine"
                    className="mb-2.5 w-[30%] sm:w-full md:hidden"
                  />
                )}
                <div className="relative bg-white sm:ml-0 sm:w-full sm:flex-none sm:self-stretch sm:py-5">
                  <img
                    src="/images/proposal2.png"
                    alt="Proposal"
                    className="w-[30vw] md:w-[360px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
